import React, { useState } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import linkifyHtml from 'linkify-html'
import sanitizeHtml from 'sanitize-html'

const Message = ({player, date, admin, imageUrl, message, onDelete}) => {
  const [showDelete, setShowDelete] = useState(false)

  const messageContent = () => {
    if(message.type == 'text') {
      return (
        <div className='text' dangerouslySetInnerHTML={
          {__html: sanitizeHtml(linkifyHtml(message.payload.text, {defaultProtocol: 'https', target: '_blank'}))}
        } />
      )
    } else if(message.type == 'gif') {
      return (
        <img className='media' src={`https://media.giphy.com/media/${message.payload.id}/giphy.gif`}></img>
      )
    } else if(message.type == 'image') {
      return (
        <img className='media' src={message.payload.url}></img>
      )
    }
  }

  const onMouseEnter = () => {
    if (!admin) return

    setShowDelete(true)
  }

  const onMouseLeave = () => {
    if (!admin) return

    setShowDelete(false)
  }

  return (
    <div className={classNames('message', { 'admin': admin })} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
      <div className='message__author'>
        <img className='avatar' src={imageUrl} />
        <div className='player'>{player}</div>
        <div className='date'>
          { moment().diff(moment(date), 'day') < 2 ?
            moment(date).calendar(null, { sameDay: 'hh:mm a', lastDay: '[Yesterday] hh:mm a' }) :
            moment(date).format('MMMM Do YYYY, h:mm a')
          }
        </div>
      </div>
      <div className='message__body'>
        <div className='message__content'>
          {messageContent()}
          { showDelete && <div className='delete-message'><i className='fa fa-trash-o' onClick={onDelete} /></div> }
        </div>
      </div>
    </div>
  )
}

Message.propTypes = {
  admin: PropTypes.bool,
  player: PropTypes.string,
  imageUrl: PropTypes.string,
  text: PropTypes.string,
}

export default Message
